import {
    Grid,
    IconButton,
    InputAdornment,
    Popover,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import type { Theme } from '@mui/material/styles';
import React, { useState } from 'react';
import { useGetReportQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import DropdownFilter from '../../../../../layout/styledcomponents/filters/Dropdown';
import { Calendar } from 'react-date-range';
import { CustomTextField } from '../../../../../layout/styledcomponents/CustomTextField';
import moment from 'moment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { startOfYear } from 'date-fns';
import { CustomButton } from '../../../../../layout/styledcomponents/CustomButton';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useSelector } from 'react-redux';
import { selectReportAPIRefSliceData } from '../../../../../app/Slices/ReportAPIRefSlice';
import TopBookersReportGraph from './TopBookersReportGraph';
import TopBookersListReport from './TopBookersReportList';

const getCss = (theme: Theme) => `
    .rdrMonthAndYearPickers select {
        color: ${theme.palette.text.primary};
        font-size: 1rem;
        font-weight: 500;
    }

    .rdrDayNumber span {
        color: ${theme.palette.text.primary};
        font-weight: 500;
    }

    .rdrDayToday .rdrDayNumber span:after {
        background-color: ${theme.palette.secondary.main}
    }

    .rdrWeekDay {
        color: ${theme.palette.text.primary};
        font-weight: 600;
    }
`;

export default function TopBookersComponentPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const [openCalendar1, setOpenCalendar1] = useState(false);
    const [anchorElCalendar1, setAnchorElCalendar1] =
        React.useState<null | HTMLElement>(null);
    const [openCalendar2, setOpenCalendar2] = useState(false);
    const [anchorElCalendar2, setAnchorElCalendar2] =
        React.useState<null | HTMLElement>(null);
    const [staffNo, setTopStaffNo] = useState(5);
    const [fromDate, setFromDate] = useState(startOfYear(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const [checked, setChecked] = React.useState(false);
    const reportExportAPI: any = useSelector(selectReportAPIRefSliceData);

    //REPORT VIEW
    const graphView = (value: boolean | ((prevState: boolean) => boolean)) => {
        setChecked(value);
    };

    //GET REPORT
    const { data: getReport } = useGetReportQuery(
        `/reports/top-bookers?from=${moment(fromDate).format(
            'YYYY-MM-DD',
        )}&to=${moment(toDate).format('YYYY-MM-DD')}&limit=${staffNo}`,
    );

    const handleTopStaffNumber = (value: any) => {
        setTopStaffNo(value);
    };

    const handleCalendar1 = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar1(!openCalendar1);
        setAnchorElCalendar1(event.currentTarget);
    };

    const handleCalendar1Close = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar1(!openCalendar1);
        setAnchorElCalendar1(null);
    };

    const handleCalendar2 = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar2(!openCalendar2);
        setAnchorElCalendar2(event.currentTarget);
    };

    const handleCalendar2Close = (event: React.MouseEvent<HTMLElement>) => {
        setOpenCalendar2(!openCalendar2);
        setAnchorElCalendar2(null);
    };

    const theme = useTheme();

    return (
        <Grid sx={{ marginTop: isMobile ? '30px' : '0px' }}>
            <style>{getCss(theme)}</style>
            <Grid
                sx={{
                    textAlign: isMobile ? 'left' : 'right',
                    // backgroundColor: 'blue',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                }}
            >
                <Grid
                    sx={{
                        width: '100%',
                        minHeight: 'auto',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'left',
                        // backgroundColor: 'yellow',
                    }}
                >
                    <Grid
                        sx={{
                            width: 'auto',
                            // backgroundColor: 'blue',
                            marginRight: isMobile ? '0px' : '15px',
                        }}
                    >
                        <CustomTextField
                            color='dark'
                            label='From'
                            value={moment(fromDate)?.format('DD/MM/YYYY')}
                            onClick={handleCalendar1}
                            // onChange={(item:any) => [setFromDate(item)]}
                            fullWidth={isMobile}
                            InputProps={{
                                //
                                style: {
                                    height: '42px',
                                },
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            disableRipple
                                            onClick={handleCalendar1}
                                        >
                                            <DateRangeIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Popover
                            open={openCalendar1}
                            anchorEl={anchorElCalendar1}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handleCalendar1Close}
                        >
                            <Calendar
                                onChange={(item) => [setFromDate(item)]}
                                date={fromDate}
                                weekStartsOn={1}
                                rangeColors={[
                                    `${theme.palette.textAccent.main}`,
                                ]}
                                color={`${theme.palette.textAccent.main}`}
                            />
                        </Popover>
                    </Grid>
                    <Grid
                        sx={{
                            width: 'auto',
                            marginRight: isMobile ? '0px' : '15px',
                            marginTop: isMobile ? '10px' : '0px',
                        }}
                    >
                        <CustomTextField
                            label='To'
                            color='dark'
                            fullWidth={isMobile}
                            value={moment(toDate)?.format('DD/MM/YYYY')}
                            onClick={handleCalendar2}
                            InputProps={{
                                style: {
                                    height: '42px',
                                },
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            disableRipple
                                            onClick={handleCalendar2}
                                        >
                                            <DateRangeIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Popover
                            open={openCalendar2}
                            anchorEl={anchorElCalendar2}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            onClose={handleCalendar2Close}
                        >
                            <Calendar
                                onChange={(item) => [setToDate(item)]}
                                date={toDate}
                                weekStartsOn={1}
                                rangeColors={[
                                    `${theme.palette.textAccent.main}`,
                                ]}
                                color={`${theme.palette.textAccent.main}`}
                            />
                        </Popover>
                    </Grid>
                    <Grid
                        sx={{
                            width: 'auto',
                            marginRight: isMobile ? '0px' : '15px',
                            marginTop: isMobile ? '10px' : '0px',
                        }}
                    >
                        {' '}
                        <DropdownFilter
                            id={'topGuestNo'}
                            options={[
                                // { value: 'All', label: 'All' },
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' },
                                { value: 4, label: '4' },
                                { value: 5, label: '5' },
                                { value: 6, label: '6' },
                                { value: 7, label: '7' },
                                { value: 8, label: '8' },
                                { value: 9, label: '9' },
                                { value: 10, label: '10' },
                            ]}
                            handleChange={handleTopStaffNumber}
                            selectedValue={
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            marginRight: '5px',
                                        }}
                                    >
                                        Top:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                        }}
                                    >
                                        {staffNo}
                                    </Typography>
                                </Grid>
                            }
                            backgroundColor={theme.palette.neutral.main}
                            border={theme.palette.midGrey.main}
                        />
                    </Grid>
                    {/* <Grid sx={{ height: '100%' }}></Grid> */}
                </Grid>

                <Grid
                    sx={{
                        width: isMobile ? '100%' : '50%',
                        minHeight: 'auto',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'left' : 'right',
                        justifyContent: isMobile ? 'flex-start' : 'flex-end',
                        // backgroundColor:'red'
                    }}
                >
                    <Grid
                        sx={{
                            width: 'auto',
                            marginRight: isMobile ? '0px' : '15px',
                        }}
                    >
                        {checked === true ? (
                            <CustomButton
                                disableRipple
                                variant='outlined'
                                color='primary'
                                onClick={() => graphView(false)}
                                sx={{ marginRight: '5px' }}
                            >
                                <FormatListBulletedIcon fontSize='small' />
                            </CustomButton>
                        ) : (
                            <CustomButton
                                disableRipple
                                variant='outlined'
                                color='primary'
                                onClick={() => graphView(true)}
                                sx={{ marginRight: '5px' }}
                            >
                                <EqualizerIcon fontSize='small' />
                            </CustomButton>
                        )}
                        {checked === false ? (
                            <>
                                {' '}
                                {/* <CustomButton
                                    disableRipple
                                    variant='contained'
                                    color='neutral'
                                    onClick={() =>
                                        reportExportAPI?.printExport()
                                    }
                                    sx={{ marginRight: '5px' }}
                                >
                                    <PrintIcon fontSize='small' />{' '}
                                </CustomButton> */}
                                <CustomButton
                                    disableRipple
                                    variant='contained'
                                    color='neutral'
                                    onClick={() =>
                                        reportExportAPI?.csvExport({
                                            fileName: 'Top Bookers Report',
                                            columnsStyles: {
                                                createdAt: {
                                                    numFmt: 'dd/mm/yyyy',
                                                },
                                            },
                                        })
                                    }
                                    sx={{ marginRight: '5px' }}
                                >
                                    <FileDownloadIcon fontSize='small' />{' '}
                                </CustomButton>
                            </>
                        ) : null}
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                {checked === true ? (
                    <TopBookersReportGraph data={getReport} />
                ) : (
                    <TopBookersListReport data={getReport} />
                )}
            </Grid>
        </Grid>
    );
}
